import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const creatorHostStyleId = 'wb-v2-surface-creator-host-theme';

export const creatorHostBridgeStyles = {
  'wb-surface-creator-host': {
    // Identity + body share the primary canvas — no gray rail band.
    '--local-creator-canvas-bg': tokens.color.background.primary,
    '--local-creator-identity-bg': tokens.color.background.primary,
    '--local-creator-identity-border': tokens.color.border.secondary,
    '--local-creator-column-border': tokens.color.border.secondary,
    '--local-creator-column-border-width': tokens.borderWidth.sm,
    '--local-creator-gap': tokens.spacing.xl,
    // Vertical stays compact; horizontal opens up so fields aren't flush to the rail/edge.
    '--local-creator-padding-y': tokens.spacing.xl,
    '--local-creator-padding-x': tokens.spacing.threeXl,
    '--local-creator-identity-width': '320px',

    // Thin, low-contrast scroll chrome (Firefox + WebKit).
    '--local-creator-scrollbar-size': '6px',
    '--local-creator-scrollbar-thumb': tokens.color.border.primary,
    '--local-creator-scrollbar-thumb-hover': tokens.color.border.secondaryAlt,
    '--local-creator-scrollbar-track': 'transparent',
    '--local-creator-scrollbar-radius': tokens.radius.full,

    // Status / error banners.
    '--local-creator-error-bg': tokens.color.background.errorPrimary,
    '--local-creator-error-border': tokens.color.border.error,
    '--local-creator-error-text': tokens.color.text.errorPrimary,
    '--local-creator-error-radius': tokens.radius.md,
    '--local-creator-banner-padding-y': tokens.spacing.md,
    '--local-creator-banner-padding-x': tokens.spacing.lg,
  },
  // Identity rail is the heading, not a form row. Match creator section titles
  // (Details / Classification) so Customer and Site read as prime labels.
  'wb-surface-creator-host .creator-identity wb-field': {
    '--local-field-label-color': tokens.color.text.primary,
    '--local-field-label-font-size': tokens.font.size.textMdBase,
    '--local-field-label-font-weight': tokens.font.weight.semibold,
    '--local-field-label-line-height': tokens.lineHeight.textMd,
    '--local-field-gap': tokens.spacing.sm,
  },
};

export function mountCreatorHostTheme(document: Document): void {

  DesignSystem.Mount(document, creatorHostStyleId, creatorHostBridgeStyles);
}
